import React, { Suspense, useCallback, useState } from 'react';
import { PageSpinner, Button, Spinner } from '@td-client-frontend/common';
import { useAxios } from '../../context/AxiosContext';
import { downloadFileFromResponse } from '../../utils/fileDownload';
import { GroupSearchSelect } from '../../components/GroupSearchSelect';
import WithPermission from '../../components/WithPermission';
import { format } from 'date-fns';
import { Permissions } from '../../@types/Permissions';

const ManageReports = () => {
  const { authAxios } = useAxios();
  const [selectedGroup, setSelectedGroup] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const getReport = useCallback(() => {
    setLoading(true);
    const groupId: string = selectedGroup?.id || '';
    const now: string = format(new Date(), 'MM-dd-yyyy');
    const fileName: string = `Eligible_Member_Report_${now}.xlsx`;
    authAxios
      .get('/reports/Eligible_Member_Report', {
        params: {
          ...(groupId ? { groupId } : {}),
          fileName
        },
        responseType: 'blob'
      })
      .then((res) => downloadFileFromResponse(res, fileName))
      .finally(() => {
        setLoading(false);
      });
  }, [authAxios, selectedGroup]);

  const handleSelect = (selectedItem: any) => {
    setSelectedGroup(selectedItem);
  };

  return (
    <div className="flex flex-col items-center justify-between w-full px-6 py-4 pt-10 mx-auto bg-white sm:items-baseline">
      <div className="w-full mt-8 mb-12 font-effra">
        <h1 className="text-4xl pb-6">Reports</h1>
        <span>
          Select a group for membership eligibility. Note: changes made to member records within the last 24 hours may
          not be reflected
        </span>
      </div>
      <div className="flex font-effra justify-start items-center">
        <div className="flex">
          <GroupSearchSelect
            placeholder="Search..."
            onSelect={handleSelect}
            value={selectedGroup}
            requiredPerm={Permissions.ReportEligibilityRead}
            includeAll
            activeOnly
          />
        </div>
        <WithPermission requiredPerms={[Permissions.ReportEligibilityRead]}>
          <div className="ml-4">
            <Button
              className="h-12"
              disabled={loading}
              data-testid="downloadReportButton"
              kind="secondary"
              onClick={getReport}
              name="downloadReport"
            >
              {!loading && <p>Download Members</p>}
              {loading && (
                <div className="flex items-center justify-center mx-12">
                  <Spinner />
                </div>
              )}
            </Button>
          </div>
        </WithPermission>
      </div>
    </div>
  );
};

const SuspenseWithLoader = () => {
  return (
    <Suspense fallback={<PageSpinner />}>
      <ManageReports />
    </Suspense>
  );
};

export default SuspenseWithLoader;
